export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/86ce1f0327d25d10c0ecd5f109ff0565.jpg"
          alt="オフィス環境"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative h-full flex items-end pb-24 px-8">
        <div className="w-full max-w-2xl">
          <div className="inline-block mb-6 px-4 py-2 border border-white/40 rounded-full backdrop-blur-sm">
            <span className="text-white text-sm font-medium">本体料金0円・月額定額制</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-light text-white leading-tight mb-8 whitespace-nowrap" style={{ fontFamily: 'serif' }}>
            買わない選択で、<br />
            オフィスはもっと軽くなる
          </h1>

          <button
            onClick={scrollToContact}
            className="bg-[#14B8A6] text-white px-8 py-4 rounded-lg text-base font-medium hover:bg-[#0F9B8E] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            今すぐ無料相談
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
